import { mapState, mapGetters, mapActions, mapMutations } from 'vuex'
import Loading from '@/components/Core/Loading'
import ApiManager from '@/utils/ApiManager'
import Constants from '@/utils/Constants'
import Utility from '@/utils/Utility'
import Validator from '@/utils/Validator'
import Item from './Item'

export default {
  name: 'ServiceMailMagazine',
  components: {
    Loading,
    Item
  },
  metaInfo () {
    let title = this.categoryName + '管理 | ' + Constants.SiteInfo.title
    this.setMeta({ title: title })
    return this.getMeta
  },
  props: {
    serviceId: String
  },
  data () {
    return {
      loading: true,
      processing: false,
      registerHash: Constants.RegisterHash,

      // 変更
      modifyTargetId: null,
      deleteTargetId: null
    }
  },
  // beforeMount () {
  //   if (this.getPermission('Member')) return
  //   this.$router.push({name: 'Home'})
  // },
  mounted () {
    this.init()
    this.initRegister()
  },
  computed: {
    ...mapState({
      categoryName: state => state.serviceMailMagazine.categoryName,
      serviceName: state => state.serviceMailMagazine.serviceName,

      // model
      magazineModel: state => state.serviceMailMagazine.magazineModel,
      deliveryTypeMstModel: state => state.serviceMailMagazine.deliveryTypeMstModel,
      relationalNoticeTypeModel: state => state.serviceMailMagazine.relationalNoticeTypeModel,
      // noticeTypeMstModel: state => state.serviceMailMagazine.noticeTypeMstModel,

      // form
      values: state => state.serviceMailMagazine.values,

      // confirm
      confirmKey: state => state.confirm.key,
      confirmAccepted: state => state.confirm.accept
    }),
    ...mapGetters({
      getMeta: 'meta/get',
      permittedView: 'permission/permittedView',
      isSmartPhone: 'core/isSmartPhone',
      isRegister: 'serviceMailMagazine/isRegister',
      isModify: 'serviceMailMagazine/isModify'
    }),

    // title
    formTitle () {
      const id = Utility.getObjectArrayValue(this.magazineModel, 'serviceMailMagazineUuid', this.modifyTargetId, 'serviceMailMagazineId')
      return this.isRegister ?
        this.categoryName + '登録' :
        this.categoryName + '変更（Id : ' + id + '）'
    },
    formButtonLabel () {
      return this.isRegister ? '登録' : '変更'
    },

    // list
    deliveryTypeList () {
      let list = []
      this.deliveryTypeMstModel.forEach(item => list.push({
        value: item.deliveryTypeMstUuid,
        label: item.deliveryTypeName
      }))
      return list
    },
    noticeTypeList () {
      try {
        return this.relationalNoticeTypeModel
          .filter(item => item.deliveryTypeMstUuid === this.inpDeliveryTypeMstId)[0].noticeTypeInfo
          .map(item => {
            return {
              value: item.noticeTypeMstUuid,
              label: item.noticeTypeName
            }
          })
      // eslint-disable-next-line
      } catch (e) {
        return []
      }
    },
    // noticeTypeMstList () {
    //   let list = []
    //   this.noticeTypeMstModel.forEach(item => list.push({
    //     value: item.noticeTypeMstUuid,
    //     label: item.noticeTypeName
    //   }))
    //   return list
    // },
    searchModeList () {
      return Constants.SearchMode
    },

    // input
    inpMailMagazineName: {
      get () {
        return this.values.inpMailMagazineName
      },
      set (value) {
        this.setInputValue({
          key: 'inpMailMagazineName',
          value: value
        })
      }
    },
    inpMailAddress: {
      get () {
        return this.values.inpMailAddress
      },
      set (value) {
        this.setInputValue({
          key: 'inpMailAddress',
          value: value
        })
      }
    },
    inpDeliveryTypeMstId: {
      get () {
        return this.values.inpDeliveryTypeMstId
      },
      set (value) {
        this.setInputValue({
          key: 'inpDeliveryTypeMstId',
          value: value
        })
      }
    },
    inpNoticeTypeMstId: {
      get () {
        return this.values.inpNoticeTypeMstId
      },
      set (value) {
        this.setInputValue({
          key: 'inpNoticeTypeMstId',
          value: value
        })
      }
    },
    inpKeyword: {
      get () {
        return this.values.inpKeyword
      },
      set (value) {
        this.setInputValue({
          key: 'inpKeyword',
          value: value
        })
      }
    },
    inpKeywordSearchType: {
      get () {
        return this.values.inpKeywordSearchType
      },
      set (value) {
        this.setInputValue({
          key: 'inpKeywordSearchType',
          value: value
        })
      }
    },
    inpIgnoreKeyword: {
      get () {
        return this.values.inpIgnoreKeyword
      },
      set (value) {
        this.setInputValue({
          key: 'inpIgnoreKeyword',
          value: value
        })
      }
    },

    // enable
    showList () {
      return this.magazineModel.length > 0
    },
    disableNoticeType () {
      return !this.inpDeliveryTypeMstIdIsValid
    },

    // validate
    inpMailMagazineNameIsValid () {
      return Validator.validText(this.inpMailMagazineName)
    },
    inpMailAddressIsValid () {
      return Validator.validText(this.inpMailAddress)
    },
    inpDeliveryTypeMstIdIsValid () {
      return Validator.validText(this.inpDeliveryTypeMstId)
    },
    inpNoticeTypeMstIdIsValid () {
      return Validator.validText(this.inpNoticeTypeMstId)
    },
    formIsValid () {
      return this.inpMailMagazineNameIsValid &&
        this.inpMailAddressIsValid &&
        this.inpDeliveryTypeMstIdIsValid &&
        this.inpNoticeTypeMstIdIsValid
    },
    disablePostButton () {
      return !this.formIsValid
    }
  },
  watch: {
    inpDeliveryType: function (to) {
      this.inpNoticeTypeMstId = ''
    },
    confirmAccepted: function (to) {
      console.log('confirmKey : ', this.confirmKey)
      // 登録
      if (this.confirmKey === 'register') {
        if (to) this.postData()
      }
      // 削除
      if (this.confirmKey === 'delete') {
        if (to) this.deleteData()
      }
    }
  },
  methods: {
    ...mapActions({
      setMeta: 'meta/set',
      showError: 'error/show',
      showConfirm: 'confirm/show',
      showToast: 'toast/show',
      loadModel: 'serviceMailMagazine/loadModel',
      initRegister: 'serviceMailMagazine/initRegister',
      initModify: 'serviceMailMagazine/initModify',
      showServiceRegistMailMagazineModal: 'serviceRegistMailMagazineModal/show',
    }),
    ...mapMutations({
      setInputValue: 'serviceMailMagazine/setInputValue',
    }),

    init () {
      this.loading = true

      //
      let magazineParams = {
        serviceUuid: this.serviceId
      }
      let deliveryTypeMstParams = {}
      // let noticeTypeMstParams = {}

      // データ読出し
      this.loadModel({
        magazineParams: magazineParams,
        deliveryTypeMstParams: deliveryTypeMstParams,
        // noticeTypeMstParams: noticeTypeMstParams
      })
        // eslint-disable-next-line
        .then(res => {
          this.loading = false
        })
        .catch(error => {
          this.showError(error || null)
        })
    },

    // ファイル登録
    confirmData() {
      const id = Utility.getObjectArrayValue(this.magazineModel, 'serviceMailMagazineUuid', this.modifyTargetId, 'serviceMailMagazineId')
      this.showConfirm({
        key: 'register',
        title: '',
        body: this.isRegister ?
          'この内容で' + this.categoryName + 'を登録しますか？' :
          '「Id : ' + id + '」の' + this.categoryName + '情報を変更しますか？'
      })
    },
    postData () {
      this.processing = true

      var makeArray = function (str) {
        const key = '@@@@@'
        return str.split(' ').join(key).split('　').join(key).split(key)
      }

      //TODO
      let parameters = {
        serviceUuid: this.serviceId,
        request: {
          mailMagazineName: this.inpMailMagazineName,
          mailMagazineAddress: this.inpMailAddress,
          deliveryTypeMstUuid: this.inpDeliveryTypeMstId,
          noticeTypeMstUuid: this.inpNoticeTypeMstId
        }
      }
      if (this.inpKeyword.length) {
        parameters.request.keywords = makeArray(this.inpKeyword)

        if (this.inpKeywordSearchType !== null) {
          parameters.request.keywordsQueryKbn = this.inpKeywordSearchType
        }
      } else {
        parameters.request.keywords = []
      }

      if (this.inpIgnoreKeyword.length) {
        parameters.request.exclusiveKeywords = makeArray(this.inpIgnoreKeyword)
      } else {
        parameters.request.exclusiveKeywords = []
      }

      if (this.isModify) {
        parameters.serviceMailMagazineUuid = this.modifyTargetId
      }
      console.log('register data', parameters)

      // 登録
      ApiManager.request(
        ['serviceMailMagazine'],
        [this.isRegister ?
          'v1ServiceMailMagazinePost' :
          'v1ServiceMailMagazinePut'],
        [parameters])
        .then(res => {
          this.processing = false
          let status = Utility.parseResponse(res)

          if (status.result) {
            // toast
            this.showToast({
              title: this.isRegister ?
                '新しい' + this.categoryName + 'の登録' :
                this.categoryName + '情報の変更',
              body: this.isRegister ?
                this.categoryName + 'を登録しました。' :
                this.categoryName + 'を変更しました。'
            })

            // this.modifyTargetId = null

            // 一覧データを再読出し
            this.init()
            this.registerItem()
          } else if (status.error) {
            // エラーメッセージ表示
            this.showError(res)
          } else {
            // アプリケーションエラー表示
            this.showError(null)
          }
          
        })
        // eslint-disable-next-line
        .catch(error => {
          this.processing = false
          this.showError(null)
        })
    },
    deleteData () {
      this.processing = true

      //
      let parameters = {
        serviceUuid: this.serviceId,
        serviceMailMagazineUuid: this.deleteTargetId
      }
      console.log('register data', parameters)

      // 登録
      ApiManager.request(
        ['serviceMailMagazine'],
        ['v1ServiceMailMagazineDelete'],
        [parameters])
        .then(res => {
          this.processing = false
          let status = Utility.parseResponse(res)

          if (status.result) {
            // toast
            this.showToast({
              title: this.categoryName + '情報の削除',
              body: this.categoryName + 'を削除しました。'
            })

            this.deleteTargetId = null
            this.modifyTargetId = null
            this.initRegister()

            // 一覧データを再読出し
            this.init()

          } else if (status.error) {
            // エラーメッセージ表示
            this.showError(res)
          } else {
            // アプリケーションエラー表示
            this.showError(null)
          }
          
        })
        // eslint-disable-next-line
        .catch(error => {
          this.processing = false
          this.showError(null)
        })
    },

    registerItem () {
      this.initRegister()
    },
    deliveryItem (props) {
      try {
        let data = this.magazineModel.filter(item => item.serviceMailMagazineUuid === props.id)[0]
        this.showServiceRegistMailMagazineModal({
          serviceId: this.serviceId,
          data: data
        })
      // eslint-disable-next-line
      } catch (e) {
        return
      }
    },
    modifyItem (props) {
      this.modifyTargetId = props.id
      this.initModify({
        data: this.magazineModel.filter(item => item.serviceMailMagazineUuid === props.id)[0]
      })
    },
    deleteItem (props) {
      this.deleteTargetId = props.id
      // confirm
      const id = Utility.getObjectArrayValue(this.magazineModel, 'serviceMailMagazineUuid', this.deleteTargetId, 'serviceMailMagazineId')
      this.showConfirm({
        key: 'delete',
        title: '',
        body: '「Id : ' + id + '」の' + this.categoryName + 'を削除しますか？',
        acceptLabel: '削除'
      })
    }
  }
}